define('views/ecards/ecard',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/ecard.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'ecard-container',
        tagName  : 'li',
        isRender : false,
        template : _.template(Template),
        events   : {
            'click .ecard-container': 'showEcard'
        },
        initialize: function(options){
            options = options || {};

            this.ecard = options.ecard;
            this.parent_view = options.parent_view;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());
            
        },

        loadData: function(){
            this.render();
        },

        showEcard: function(){
            this.parent_view.showPasskit();
            // pf.navigate('merchants/groups/'+this.ecard.MerchantGroupGUID+'/ecard/'+this.ecard.MerchantGUID+'/'+this.ecard.GiftCardGUID);
        },

        close: function(){}
    });
});
